import { Outlet } from 'react-router-dom';
import AppSidebar from '@/components/Sidebar/AppSidebar';
import { ProviderSideBar } from '@/components/Sidebar/Provider/ProviderSideBar';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { TooltipProvider } from '@/components/ui/tooltip';

export default function AppLayout() {
	return (
		<TooltipProvider>
			<SidebarProvider>
				<ProviderSideBar>
					<AppSidebar />
					<SidebarInset className="flex flex-col min-h-svh">
						<Outlet />
					</SidebarInset>
				</ProviderSideBar>
			</SidebarProvider>
		</TooltipProvider>
	);
}
